import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(username, password);
      navigate('/home');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.stars}>{'★ ✦ ★ ✦ ★ ✦ ★ ✦ ★'}</div>

      <div style={styles.container}>
        <div style={styles.header}>
          <img src="/banner.jpg" alt="Reyes Magos" style={styles.banner} />
          <h1 style={styles.title}>Reyes Magos</h1>
          <p style={styles.subtitle}>App familiar · Amigo invisible</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label className="label">Usuario</label>
            <input
              className="input"
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="tu.nombre"
              autoComplete="username"
              autoCapitalize="none"
              required
            />
          </div>

          <div style={styles.field}>
            <label className="label">Contraseña</label>
            <input
              className="input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          {error && <p className="error-msg">⚠ {error}</p>}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '0.8rem', marginTop: '0.5rem', fontSize: '1rem' }}
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar ✨'}
          </button>
        </form>
      </div>

      <p style={styles.footer}>Solo para uso familiar · {new Date().getFullYear()}</p>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    background: 'radial-gradient(ellipse at top, #2a1060 0%, #0f0720 60%)',
  },
  stars: {
    color: 'var(--gold)',
    fontSize: '1.1rem',
    letterSpacing: '0.4em',
    marginBottom: '2rem',
    opacity: 0.6,
  },
  container: {
    width: '100%',
    maxWidth: '440px',
    background: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: '16px',
    padding: '0 2rem 2rem',
    boxShadow: '0 8px 48px rgba(0,0,0,0.5)',
    overflow: 'hidden',
  },
  header: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    marginLeft: '-2rem',
    marginRight: '-2rem',
  },
  banner: {
    width: '100%',
    display: 'block',
    borderRadius: '16px 16px 0 0',
    marginBottom: '1rem',
  },
  title: {
    fontSize: '1.8rem',
    color: 'var(--gold)',
    marginBottom: '0.25rem',
  },
  subtitle: {
    color: 'var(--text-muted)',
    fontSize: '0.85rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
  },
  footer: {
    marginTop: '2rem',
    color: 'var(--text-muted)',
    fontSize: '0.75rem',
  },
};
